const ChevronLeftIcon = ({ className }: { className?: string }) => (
	<svg
		className={className}
		fill='currentColor'
		height='13'
		viewBox='0 0 8 13'
		width='8'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.81301 1.91119V0.703378C7.81301 0.59869 7.6927 0.540878 7.61145 0.60494L0.567698 6.1065C0.507852 6.15304 0.459426 6.21264 0.426115 6.28074C0.392804 6.34885 0.375488 6.42366 0.375488 6.49947C0.375488 6.57528 0.392804 6.6501 0.426115 6.7182C0.459426 6.7863 0.507852 6.8459 0.567698 6.89244L7.61145 12.394C7.69426 12.4581 7.81301 12.4003 7.81301 12.2956V11.0878C7.81301 11.0112 7.77707 10.9378 7.7177 10.8909L2.0927 6.50025L7.7177 2.10807C7.77707 2.06119 7.81301 1.98775 7.81301 1.91119Z'
			fill='currentColor'
		/>
	</svg>
)

export { ChevronLeftIcon }
